import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.large};
  `}
`
